import { Box } from "@mui/material";
import NewHistoryModel from "./NewHistoryModel";

function HistoryModuleScreen() {
    const searchParams = new URLSearchParams(window.location.search);
    const tableName = searchParams.get('tableName');
    const id = searchParams.get('id');
    const breadCrumb = searchParams.get('breadCrumb');
    const where = [
        {
            field: 'TableName',
            operator: 'contains',
            type: 'string',
            value: tableName
        },
        {
            field: 'PrimaryKey',
            operator: 'contains',
            type: 'string',
            value: id
        }
    ];
    return (
        <Box>
            <NewHistoryModel.Grid baseFilters={where} title={`History > ${breadCrumb}`} />
        </Box>
    );
}

export default HistoryModuleScreen;